import React, { useEffect } from 'react'
import aboutimg from './images/about.avif'
import aboutimg_shape from './images/about_shape.svg'
import {Link} from 'react-router-dom'

import AOS from "aos";
import "aos/dist/aos.css";

const HomeAbout = () => {


    useEffect(() => {
        AOS.init();
    }, []);


    return (
        <div className='HomeAbout_section'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-6  HomeAbout_section_img' data-aos="zoom-in" data-aos-duration="2000">
                        <div >
                            <img src={aboutimg} className='img-fluid HomeAbout_section_img1' />
                        </div>
                        <div >
                            <img src={aboutimg_shape} className='img-fluid HomeAbout_section_img2' />
                        </div>
                        <div>

                        </div>
                    </div>
                    <div className='col-md-6 HomeAbout_section_content' data-aos="fade-up" data-aos-duration="2000">
                        <p className='HomeAbout_section_fpcontent' data-aos="fade-up" data-aos-duration="2000">Get More About Us</p>
                        <h3>A Single Location for Thousands of Top Courses</h3>

                        <p className='text-justify'>At Hamo Tech, we are committed to providing high-quality training programs that empower individuals to excel in today's competitive tech industry. With expert mentors, industry-approved courses, and hands-on learning, we bridge the gap between education and employment.</p>
                        <p className='text-justify'>Our institute focuses on equipping learners with practical skills and real-world knowledge to achieve career success.</p>

                        <ul>
                            <li>🌟 The Most World-Class Instructors</li>
                            <li>💻 Access Your Class Anywhere</li>
                            <li>📅 Flexible Course Plans</li>
                            <li>🛠️ Hands-On Training</li>
                        </ul>

                        <Link to="/user-courses" ><button>Know More <span><i class="ri-arrow-right-line"></i></span></button></Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeAbout
